import React from 'react';
import * as ReactDOM from 'react-dom';
import {post} from '../../utils/request';
import api from './api';
import { ListView, Badge } from 'antd-mobile';
import { href } from '../../utils/util';
import './index.less';


const NUM_SECTIONS = 5;
const NUM_ROWS_PER_SECTION = 5;
let pageIndex = 0;

let dataBlobs = {};
let sectionIDs = [];
let rowIDs = [];
function genData(pIndex = 0) {
  for (let i = 0; i < NUM_SECTIONS; i++) {
    const ii = (pIndex * NUM_SECTIONS) + i;
    const sectionName = `Section ${ii}`;
    sectionIDs.push(sectionName);
    dataBlobs[sectionName] = sectionName;
    rowIDs[ii] = [];

    for (let jj = 0; jj < NUM_ROWS_PER_SECTION; jj++) {
      const rowName = `S${ii}, R${jj}`;
      rowIDs[ii].push(rowName);
      dataBlobs[rowName] = rowName;
    }
  }
  sectionIDs = [...sectionIDs];
  rowIDs = [...rowIDs];
}


class safetyTraining extends React.Component {
  constructor(props) {
    super(...props);

    const getSectionData = (dataBlob, sectionID) => dataBlob[sectionID];
    const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID];
    const dataSource = new ListView.DataSource({
      getRowData,
      getSectionHeaderData: getSectionData,
      rowHasChanged: (row1, row2) => row1 !== row2,
      sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
    });

    sectionIDs = [];
    rowIDs = [];
    dataBlobs = {};
    pageIndex = 0;

    this.state = {
      dataSource,
      isLoading: true,
      hasMore: true,
      height: document.documentElement.clientHeight * 5 / 4,
      data: [],
      skipCount: 0,
      pageSize: 5,
    }
  }

  componentWillMount() {
    const search = window.location.hash.split('?')[1];
    
  }

  getQuerySafeList(type){
    const {skipCount, pageSize} = this.state;
    post({
      url: api.querySafeList,
      data:{
        skipCount: skipCount * pageSize,
        pageSize: pageSize
      }
    }).then((res) => {
        // console.log('查询安全培训列表', res)
        // Toast.info(res.msg,1);
        if(res.result === 'success' && res.data || res.data.length > 0){
          this.setState({
            data: res.data
          },()=>{
            if(sectionIDs.length >= res.count){
              this.setState({
                hasMore: false
              });
            }
            if(type){
              this.setState({
                dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
                isLoading: false,
              });
            }else{
              const hei = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop;
              this.setState({
                dataSource: this.state.dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
                isLoading: false,
                height: hei,
              });
            }
          });
        }else{
          
        }
    }, (res)=>{
        console.log('查询安全培训列表失败', res)
    });
  }

  componentDidMount() {
    // simulate initial Ajax
    setTimeout(() => {
      genData();
      this.getQuerySafeList()
    }, 600);
  }

  onEndReached = (event) => {
    // load new data
    // hasMore: from backend data, indicates whether it is the last page, here is false
    if (this.state.isLoading || !this.state.hasMore) {
      return;
    }
    console.log('reach end', event);
    this.setState({ isLoading: true });
    setTimeout(() => {
      pageIndex++;
      genData(pageIndex);
      this.setState({
        skipCount: pageIndex
      },()=>{
        this.getQuerySafeList(1)
      });
    }, 1000);
  }

  
  
  render() {
    const {data} = this.state;
    // let index = data.length - 1;
    let index = 0;
    const row = (rowData, sectionID, rowID) => {
      
      let obj = {};
      if(index <= data.length - 1){
          obj = data[index++];
      }else{
          return (<div></div>)
      }
      
      return (
        <div className="item" key={rowID} onClick={()=>{
            window.location.href= obj.contentLinkUrl;
        }}>
            <div className="bg" style={{background: `url(${obj.indexImg}) no-repeat center center `, backgroundSize: 'cover'}}></div>
            <div className="itemContent">
              <h2>
                  {obj.contentTitle}
              </h2>
              <div className="source">
              {obj.contentRemark}
              </div>
              <div className="itemFooter">
                <Badge text={obj.contentAttr}
                  style={{
                    backgroundColor: '#10C2B0',
                    borderRadius: 2,
                    color: '#fff',
                    border: '1px solid #10C2B0',
                  }}
                />
                <span className="time">{obj.gmtCreate}</span>
              </div>
            </div>
        </div>
      );

      // if(!data[index--]){
      //   return (<div></div>)
      // }
      // if (index < 0) {
      //   index = data.length - 1;
      // }
      // const obj = data[index--];
      // return (
      //   <div className="item" key={rowID} onClick={()=>{
      //       window.location.href= obj.contentLinkUrl;
      //   }}>
      //       <div className="bg" style={{background: `url(${obj.indexImg}) no-repeat center center `, backgroundSize: 'cover'}}></div>
      //       <div className="itemContent">
      //         <h2>
      //             {obj.contentTitle}
      //         </h2>
      //         <div className="source">
      //         {obj.contentRemark}
      //         </div>
      //         <div className="itemFooter">
      //           <Badge text={obj.contentAttr}
      //             style={{
      //               backgroundColor: '#10C2B0',
      //               borderRadius: 2,
      //               color: '#fff',
      //               border: '1px solid #10C2B0',
      //             }}
      //           />
      //           <span className="time">{obj.gmtCreate}</span>
      //         </div>
      //       </div>
      //   </div>
      // );
    };


    return (
      <div className="safetyTrainingBox">
        <ListView
          className="am-list"
          ref={el => this.lv = el}
          dataSource={this.state.dataSource}
          renderFooter={() => (<div style={{ padding: 30, textAlign: 'center' }}>
            {this.state.isLoading ? '加载中...' : '已经到底了！'}
          </div>)}
          renderRow={row}
          style={{
            height: this.state.height,
            overflow: 'auto',
          }}
          pageSize={5}
          scrollRenderAheadDistance={500}
          onEndReached={this.onEndReached}
          onEndReachedThreshold={10}
        />
      </div>
    );
  }
}

export default safetyTraining;


// WEBPACK FOOTER //
// ./src/safetyTraining/index/index.js